

<li class="overflow-hidden rounded-xl border border-gray-200">
  <div class="flex items-center gap-x-4 border-b border-gray-900/5 bg-white p-6">
    <img v-if="selectedAccount.provider == 'facebook'" src="/img/facebook-logo.svg" alt="Facebook"
      class="w-14 h-14 p-2 flex-none rounded-lg bg-white object-cover ring-1 ring-gray-100" />

    <img v-if="selectedAccount.provider == 'instagram'" src="/img/instagram-logo.png" alt="Instagram"
      class="w-14 h-14 p-2 flex-none rounded-lg bg-white object-cover ring-1 ring-gray-100" />

    <img v-if="selectedAccount.provider == 'linkedin'" src="/img/linkedin-logo.png" alt="Linkedin"
      class="h-14 p-2 flex-none rounded-lg bg-white object-cover ring-1 ring-gray-100" />


    <div v-if="!editMode" class="flex items-center space-x-2 group w-full">

      <p class="text-sm py-0 px-1 font-medium text-gray-900 border border-transparent">{{ selectedAccount.name }}</p>

      <svg @click="editMode = !editMode" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
        stroke-width="1.5" stroke="currentColor"
        class="w-3 h-3 text-gray-500 hidden group-hover:block hover:text-brandhelfer-blue cursor-pointer">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
      </svg>
    </div>


    <div v-if="editMode" class="flex items-center space-x-2 group w-full">

      <form @submit="submit" class="flex items-center space-x-2">
        <input v-model="selectedAccount.name" autofocus type="text" maxlength="20"
          class="py-0 px-1 text-sm font-medium text-gray-900 border-dashed border-gray-300 focus:border-brandhelfer-blue outline-none ring-0 focus:ring-0">
        <svg @click="submit" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor" class="w-4 h-4 text-gray-500 shrink-0 hover:text-brandhelfer-blue cursor-pointer">
          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
        </svg>
      </form>
    </div>

    <div class="relative ml-auto" v-click-outside="hideOptions">
      <button @click="showOptions = !showOptions" type="button"
        class="relative block text-gray-400 hover:text-gray-500" id="options-menu-0-button" aria-expanded="false"
        aria-haspopup="true">
        <span class="absolute -inset-2.5"></span>
        <span class="sr-only">Open options</span>
        <svg class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
          <path
            d="M3 10a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8.5 10a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM15.5 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" />
        </svg>
      </button>


      <transition enter-active-class="transition ease-out duration-300" enter-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75"
        leave-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
        <div v-if="showOptions"
          class="absolute right-0 z-10 mt-0.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-0 whitespace-nowrap focus:outline-hidden"
          role="menu" aria-orientation="vertical" aria-labelledby="options-menu-0-button" tabindex="-1">
          <!-- Active: "bg-gray-50 outline-hidden", Not Active: "" -->
          <button @click="deleteAccount" class="block px-3 py-1 text-xs text-gray-900 hover:bg-gray-100 hover:text-brandhelfer-blue hover:outline-hidden cursor-pointer" role="menuitem" tabindex="-1"
            id="options-menu-0-item-0">Account entfernen</button>
        </div>
      </transition>

    </div>
  </div>

  <dl class="bg-gray-50 -my-3 divide-y divide-gray-100 px-6 py-2 text-xs">
    <div class="flex justify-between gap-x-4 py-3">
      <dt class="text-gray-500">Zuletzt verknüpft am</dt>
      <dd class="text-gray-700"><time>{{ $filters.formatDateTime(selectedAccount.updated_at) }}</time></dd>
    </div>

    <div class="flex justify-between gap-x-4 py-3">
      <dt class="text-gray-500">Gültig bis</dt>
      <dd class="text-gray-700"><time>{{ $filters.formatDateTime(selectedAccount.expires_at) }}</time><br /><span class="font-semibold" :class="selectedAccount.expires_in_days > 0 ? 'text-brandhelfer-green' : 'text-brandhelfer-red'">{{ selectedAccount.expires_in_days }} Tag(e)</span></dd>
    </div>
  </dl>
</li>

